import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toTitleCase(str: string): string {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function formatGender(gender: string): string {
  const genderMap: Record<string, string> = {
    'man': 'Man',
    'male': 'Man',
    'woman': 'Woman',
    'female': 'Woman',
    'non-binary': 'Non-binary',
    'prefer-not-to-say': 'Prefer not to say'
  };
  return genderMap[gender] || gender;
}
